/* UD Brand interactions — scroll reveal, mobile nav, ticker duplication */
(function () {
  'use strict';

  /* ----- Scroll-reveal ----- */
  function initReveal() {
    var els = document.querySelectorAll('.ud-reveal');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ----- Ticker: duplicate track items so the marquee loops seamlessly ----- */
  function initTicker() {
    document.querySelectorAll('.ud-ticker__track').forEach(function (track) {
      if (track.dataset.tickerInit) return;
      track.dataset.tickerInit = '1';
      var clone = track.innerHTML;
      track.innerHTML = clone + clone;
    });
  }

  /* ----- Mobile nav drawer ----- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-ud-nav-toggle]');
    var drawer = document.querySelector('[data-ud-nav-drawer]');
    if (!toggle || !drawer) return;
    var closeBtn = drawer.querySelector('[data-ud-nav-close]');
    function open() {
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.removeAttribute('data-open');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close();
    });
  }

  /* ----- Live cart count bridge ----- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-ud-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
    });
  }

  function refreshCartCount() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') updateCartCount(c.item_count); })
      .catch(function () { /* ignore */ });
  }

  /* ----- Shipping threshold copy guard -----
     The free-shipping threshold moved to £60, but "over £50" / "over £49"
     copy is baked into dozens of product template settings. This rewrites
     those exact phrases at render time so every page shows the current
     threshold. Update here if the threshold ever changes again. */
  function fixShippingCopy(root) {
    try {
      var scope = root && root.nodeType === 1 ? root : document.body;
      if (!scope) return;
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var v = node.nodeValue;
        if (v && (v.indexOf('over £50') !== -1 || v.indexOf('over £49') !== -1)) {
          v = v.replace(/over £49(?!\d)/g, 'over £60').replace(/over £50(?!\d)/g, 'over £60');
          node.nodeValue = v;
        }
      }
    } catch (e) { /* non-critical */ }
  }

  var udFixObserverStarted = false;
  function startFixObserver() {
    if (udFixObserverStarted || !window.MutationObserver || !document.body) return;
    udFixObserverStarted = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { fixShippingCopy(document.body); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initReveal();
    initTicker();
    initMobileNav();
    refreshCartCount();
    fixShippingCopy(document.body);
    startFixObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Listen for Shopify section reloads in the theme editor */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', refreshCartCount);
})();
